import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Grid } from '@material-ui/core'
import { SpacingContainer } from '../../components/common/Containers'
import { emptyArray } from '../../utils/arrayUtils'
import NothingFoundCard from '../../components/generics/Cards/NothingFoundCard/NothingFoundCardList'
import connect from './connect'
import Header from './components/Header'
import List from './components/List'

const OrganizationRoleEditor = ({ authUser, rolesList, getRolesList }) => {
  const navigate = useNavigate()
  const [arrayRoles, setArrayRoles] = useState([])

  useEffect(() => {
    getRolesList()
  }, [])

  useEffect(() => {
    if (Array.isArray(rolesList)) {
      setArrayRoles(rolesList)
    }
  }, [rolesList])

  useEffect(() => {
    if (
      authUser &&
      (authUser.role === 'manager' || authUser.role === 'consulting')
    ) {
      navigate('/organizations')
    }
  }, [authUser])

  return (
    <SpacingContainer py={7} px={7}>
      <Header />
      {!emptyArray(arrayRoles) ? (
        <Grid container spacing={2} direction="column">
          <Grid item xs zeroMinWidth>
            <List />
          </Grid>
        </Grid>
      ) : (
        <Grid item xs zeroMinWidth>
          <NothingFoundCard />
        </Grid>
      )}
    </SpacingContainer>
  )
}

export default connect(OrganizationRoleEditor)
